import { render, staticRenderFns } from "./EditRevenueModal.vue?vue&type=template&id=201d4c7a&"
import script from "./EditRevenueModal.vue?vue&type=script&lang=ts&"
export * from "./EditRevenueModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports